import {
  Children,
  Fragment,
  isValidElement,
  type OptionHTMLAttributes,
  type ReactNode,
} from 'react';

export interface SelectOptionItem {
  value: string;
  label: string;
  disabled: boolean;
}

export function foldSelectSearchText(value: string): string {
  return value.trim().toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
}

function textFromNode(node: ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (node === null || node === undefined || typeof node === 'boolean') {
    return '';
  }
  if (Array.isArray(node)) {
    return node.map(textFromNode).join('');
  }
  if (isValidElement(node)) {
    return textFromNode((node.props as { children?: ReactNode }).children);
  }
  return '';
}

export function collectSelectOptions(children: ReactNode): SelectOptionItem[] {
  const items: SelectOptionItem[] = [];

  Children.forEach(children, (child) => {
    if (!isValidElement(child)) {
      return;
    }
    if (child.type === Fragment) {
      items.push(...collectSelectOptions((child.props as { children?: ReactNode }).children));
      return;
    }
    if (child.type === 'optgroup') {
      items.push(...collectSelectOptions((child.props as { children?: ReactNode }).children));
      return;
    }
    if (child.type !== 'option') {
      return;
    }
    const props = child.props as OptionHTMLAttributes<HTMLOptionElement>;
    const label = textFromNode(props.children);
    const value = props.value !== undefined ? String(props.value) : label;
    items.push({ value, label, disabled: props.disabled === true });
  });

  return items;
}
